import {
  decorateLeafletPathDualDash
} from './portal-dual-dash.js'

const createLayerCoreController = function ({
  $ = window.jQuery,
  _ = window._,
  L = window.L,
  momentRef = window.moment,
  windowRef = window,
  areaSwal = window.Swal,
  fnT = function (key) { return String(key || '') },
  fnIsValidLayerCord = function () { return true },
  fnGetMap = function () { return null },
  fnGetDb = function () { return {} },
  fnGetNotamItems = function () { return null },
} = {}) {

  let layersOnMap = {}

  const cordKey = function (cord) {
    return 'key_' + JSON.stringify(cord).replace(/ /g, '_')
  }

  const cordIsOnMap = function (row, addToMap) {
    const shouldAdd = (typeof addToMap === 'undefined') ? true : !!addToMap
    const onMapKey = cordKey(row.cord)
    const isOnMap = Object.prototype.hasOwnProperty.call(layersOnMap, onMapKey)
    if (!isOnMap) {
      layersOnMap[onMapKey] = {
        layer: false,
        airspace_class_ids: [],
        rows: []
      }
    }
    if (shouldAdd) {
      layersOnMap[onMapKey].airspace_class_ids.push(row.airspace_class_id)
      layersOnMap[onMapKey].rows.push(row)
    }
    return isOnMap ? layersOnMap[onMapKey] : false
  }

  const layerFilterAll = function () {
    const map = fnGetMap()
    const db = fnGetDb() || {}
    const notamItems = fnGetNotamItems()
    if (!map || !notamItems || !db.settings) return
    const dateFrom = momentRef().set({ h: 0, m: 0 }).format('YYMMDDHHmm')
    const dateTo = momentRef().set({ h: 23, m: 59 }).format('YYMMDDHHmm')
    const isNotamMasterEnabled = map.hasLayer(notamItems)
    $.each(layersOnMap, function (_onMapKey, lom) {
      let isLayerVisible = false
      $.each(lom.rows, function (_k, row) {
        if (row.source === 'notam__flightplan.romatsa.ro' && db.settings.filter && db.settings.filter.date && db.settings.filter.date === 'today') {
          const bUnderFilter =
            row.body.inf.date.from > dateFrom &&
            row.body.inf.date.to > dateFrom &&
            row.body.inf.date.from > dateTo &&
            row.body.inf.date.to > dateTo
          const bOverFilter =
            row.body.inf.date.from < dateFrom &&
            row.body.inf.date.to < dateFrom &&
            row.body.inf.date.from < dateTo &&
            row.body.inf.date.to < dateTo
          const bFilterDateToday = (bUnderFilter || bOverFilter) ? false : true
          isLayerVisible = isLayerVisible || bFilterDateToday
        } else {
          isLayerVisible = true
        }
      })
      const hasNotamRows = lom.rows.some(function (row) { return row.source === 'notam__flightplan.romatsa.ro' })
      if (hasNotamRows && !isNotamMasterEnabled) {
        isLayerVisible = false
      }
      if (lom.layer) {
        if (isLayerVisible && _.intersection(db.settings.overlayActive, lom.airspace_class_ids).length) {
          lom.layer.addTo(map)
        } else {
          lom.layer.removeFrom(map)
        }
      } else {
        console.error(fnT('log.missing_layer'))
      }
    })
  }

  const layerBuilder = function (row, didOpen) {
    const map = fnGetMap()
    const db = fnGetDb() || {}
    if (typeof didOpen !== 'function') {
      didOpen = function () {}
    }
    if (!fnIsValidLayerCord(row.shape, row.cord)) {
      console.error(fnT('log.invalid_coord_array'), row.cord, row)
      return false
    }
    const layer = decorateLeafletPathDualDash(L[row.shape](row.cord, row.style), { L: L })
    $(layer).on('mouseover', function () {
      layer.setStyle({
        opacity: 0.8,
        fillOpacity: 0.5
      })
    }).on('mouseleave', function () {
      layer.setStyle({
        opacity: 0.6,
        fillOpacity: 0.3
      })
    })
    const labelText = windowRef.airSpaceTypes[row.airspace_class_id].short + ' - ' + row.label
    layer.bindTooltip(labelText, { direction: 'center', className: 'portal-map-label', sticky: true })
    windowRef.airSpaceTypes[row.airspace_class_id].overlay.addLayer(layer)
    if (db.settings && Array.isArray(db.settings.overlayActive) && db.settings.overlayActive.includes(row.airspace_class_id)) {
      windowRef.airSpaceTypes[row.airspace_class_id].overlay.addTo(map)
    }
    const onMapKey = cordKey(row.cord)
    layersOnMap[onMapKey].layer = layer
    $(layer).on('click', function () {
      areaSwal.fire({
        title: labelText,
        didOpen: didOpen
      })
    })
    return layer
  }

  const resetLayersOnMap = function () {
    layersOnMap = {}
  }

  return {
    cordKey: cordKey,
    cordIsOnMap: cordIsOnMap,
    layerFilterAll: layerFilterAll,
    layerBuilder: layerBuilder,
    resetLayersOnMap: resetLayersOnMap
  }
}

export {
  createLayerCoreController
}
